// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import icons from '../../assets/styles/icons.scss';

import style from './CollapsibleButton.scss';

import type { Node } from 'react';

type Props = {
  children: Node;
  id?: string;
  titleIntl: string;
  subtitleIntl?: string;
  subtitleExtra?: string;
  initialOpen?: boolean;
  disabled?: boolean;
};

type State = {
  open: boolean;
};

export default class CollapsibleButton extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: !!props.initialOpen,
    }
  }

  render() {
    const { id, titleIntl, subtitleIntl, subtitleExtra, disabled } = this.props;
    const { open } = this.state;
    return (
      <div id={id ? id : undefined} className={style.baseWrap} data-open={`${open}`}>
        <button className={classNames(style.collapse, { [style.single]: !subtitleIntl && !subtitleExtra })}
                disabled={disabled}
                onClick={(e: Event) => this.setState((st: State) => ({ open: !st.open }))}>
          <div className={style.textWrap}>
            <FormattedMessage id={titleIntl}>{
              txt => <p className={style.title}>{txt}</p>
            }</FormattedMessage>
            {!!subtitleIntl && <FormattedMessage id={subtitleIntl}>{
              txt => <p className={style.subtitle}>{txt}{subtitleExtra}</p>
            }</FormattedMessage>}
            {!subtitleIntl && !!subtitleExtra && <p className={style.subtitle}>{subtitleExtra}</p>}
          </div>
          <i className={!open ? icons.iconChevronDownMedium : icons.iconChevronUpMedium}/>
        </button>
        <div className={classNames(style.content, { [style.open]: !!open })}>
          <div className={style.hrWrap}>
            <hr/>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

CollapsibleButton.propTypes = {
  children: PropTypes.element.isRequired,
  id: PropTypes.string,
  titleIntl: PropTypes.string.isRequired,
  subtitleIntl: PropTypes.string,
  subtitleExtra: PropTypes.string,
  initialOpen: PropTypes.bool,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/CollapsibleButton/CollapsibleButton.jsx